import React from "react";
import SvgIcon from "e100-react-components/lib/components/SvgIcon";
import { IProps } from "e100-react-components/lib/components/SvgIcon/index";

export const Way = (props: IProps) => (
  <SvgIcon {...props}>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.33398 2.5H5.00065V17.5H3.33398V2.5ZM15.0007 2.5H16.6673V17.5H15.0007V2.5ZM10.834 3.33333H9.16732V6.66667H10.834V3.33333ZM9.16732 8.33333H10.834V11.6667H9.16732V8.33333ZM10.834 13.3333H9.16732V16.6667H10.834V13.3333Z" />
  </SvgIcon>
);
